import { clsx } from "clsx";
import type { SVGProps } from "react";
const SvgGreenPlus = ({ className, ...props }: SVGProps<SVGSVGElement>) => {
  const mergedClassName = clsx("rtl:-scale-x-100", className);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      aria-hidden="true"
      className={mergedClassName}
      {...props}
    >
      <path
        fill="url(#greenPlus_svg__a)"
        d="M12 2.854a9.147 9.147 0 1 0 0 18.293 9.147 9.147 0 0 0 0-18.293"
      />
      <path
        fill="#fff"
        d="M16.734 12.79H12.79v3.945a.789.789 0 1 1-1.579 0v-3.946H7.265a.789.789 0 1 1 0-1.578h3.945V7.265a.789.789 0 1 1 1.579 0v3.946h3.945a.789.789 0 1 1 0 1.578"
      />
      <defs>
        <linearGradient
          id="greenPlus_svg__a"
          x1={5.533}
          x2={18.467}
          y1={5.533}
          y2={18.467}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#61d18d" />
          <stop offset={1} stopColor="#4ea974" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SvgGreenPlus;
